import { useGlobalContext } from '@honeycomb/data';
import { Styler } from '@honeycomb/ui-core';
import React, { useMemo } from 'react';
export function TrustYouReviewScore({ clusterId, onClick }) {
    const { configSettings: { TrustYouReviewsAPIKey }, } = useGlobalContext();
    const isClickable = Boolean(onClick);
    const scoreSrc = useMemo(() => `https://api.trustyou.com/hotels/${encodeURIComponent(clusterId)}/trust_score.html?key=${TrustYouReviewsAPIKey}&size=xs&iframe_resizer=false&custom_style={"primaryColor": "0x69BE28"}`, [clusterId, TrustYouReviewsAPIKey]);
    return (React.createElement(Styler, { display: "flex", button: isClickable, onClick: isClickable ? onClick : undefined, "data-test-id": "trust_you_review_score" },
        React.createElement(Styler, { component: "iframe", src: scoreSrc, title: `TrustYou Review Score for hotel cluster ${clusterId}`, h: "25px", maw: "160px", style: {
                border: 'none',
                pointerEvents: 'none',
            }, scrolling: "no" })));
}
